import { FormEvent, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import CustomSelect from '../CustomSelect';
import { JanusInitActionCreator } from '../../actionCreators';
import './styles.css';

export type RegionModalStateProps = {
  error?: string;
  loading: boolean;
};

export type RegionModalDispatchProps = {
  initJanus: JanusInitActionCreator;
};

type RegionModalProps = RegionModalStateProps & RegionModalDispatchProps;

const options = [
  {
    label: 'Europe',
    value: 'eu',
  },
  {
    label: 'USA',
    value: 'us',
  },
];

export default function RegionModal(props: RegionModalProps): JSX.Element {
  const { error, loading, initJanus } = props;

  const location = useLocation();
  const history = useHistory();
  const [region, setRegion] = useState('');
  useEffect(() => {
    const appRoot = document.getElementById('app-root');
    if (appRoot) {
      appRoot.style.filter = 'blur(5px)';
      appRoot.style.transform = 'scale(1.03)';
    }
    return () => {
      if (appRoot) {
        appRoot.style.filter = '';
        appRoot.style.transform = '';
      }
    };
  }, []);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const search = new URLSearchParams(location.search);
    search.set('id', Date.now().toString(10));
    search.set('region', region);
    initJanus({
      region,
      then: () =>
        history.replace({
          ...history.location,
          search: search.toString(),
        }),
    });
  };

  return (
    <div className="region-modal">
      <form className="region-form" onSubmit={handleSubmit}>
        <h2>Select Region</h2>
        <label htmlFor="region">
          <p>Select the region closest to you for the best experience</p>
        </label>
        <CustomSelect
          options={options}
          onChange={(option) => setRegion(option.value)}
          value={region}
        />
        {error ? <span className="error">{error}</span> : null}
        <button disabled={loading || !region} type="submit">
          {loading ? <div className="loader" /> : 'Create Call'}
        </button>
      </form>
    </div>
  );
}
